// extracted by mini-css-extract-plugin
export default {"searchWrapper":"SearchInput_searchWrapper__QYtj+"};